import React, { useState, useEffect } from 'react';
import { useIonAlert } from '@ionic/react';
import { useLocation } from 'react-router'
import {
    Grid,
    Stack,
    Divider,
    Box,
} from '@mui/material';
import * as Forms from '../../components/UIComponents/Form';
import * as Buttons from '../../components/UIComponents/Button';
import * as Texts from '../../components/UIComponents/Text';
import AppNavigator2 from '../../components/AppNavigator2';
import config from '../../config/config';
import MustAsterik from './MustAsterik';
import LeftProgressPanel from './LeftProgressPanel';
import BotHelper from '../../helpers/BotHelper';

const UserProfileDetails = ({
    history,
    dict,
    bot,
    updateBotProfile,
    updateBotProfileBulk,
    selectedDot,
    setSelectedDot,
    children,
    resetSession
}) => {
    const [userNickname, updateUserNickname] = useState("")
    const [botNickname, updateBotNickname] = useState('');
    const [birthdate, updateBirthdate] = useState('');
    const [gender, updateGender] = useState('');
    const [relation, updateRelation] = useState('');
    const [occupation, updateOccupation] = useState('');
    const [error, setError] = useState({})
    const [presentAlert] = useIonAlert()

    // this locks the useEffect so it only gets fired when users are in this page
    const location = useLocation();
    const isActive = location.pathname === '/profilesetup/user-profile';

    const optionsArr = [
        {
            id: 'Male',
            value: 'Male',
            display: dict["male"]
        },
        {
            id: 'Female',
            value: 'Female',
            display: dict["female"]
        },
        {
            id: 'Others',
            value: 'Others',
            display: dict["othergender"]
        }
    ]

    function isValidData() {
        const errors = {}

        const userNickname = bot?.profileObj?.longMem?.userNickname || ""
        const botNickname = bot?.profileObj?.longMem?.botNickname || ""
        let birthdate = bot?.profileObj?.longMem?.userBirthdate || ""
        const gender = bot?.profileObj?.longMem?.userGender || ""
        const relation = bot?.profileObj?.longMem?.relation || ""
        const occupation = bot?.profileObj?.longMem?.userOccupation || ""

        const fields = { userNickname, botNickname, gender, relation, occupation }
        Object.keys(fields).forEach(field => {
            if (!fields[field]) {
                // console.log("error")
                errors[field] = dict[`${field}ValidationError`]
            }
        })

        if (!birthdate || typeof birthdate !== "string") {
            birthdate = String(birthdate);
        }
        if (!/^\d{8}$/.test(birthdate)) {
            errors.birthdate = dict["birthdateValidationError"]
        } else {
            const year = parseInt(birthdate.slice(0, 4), 10)
            const month = parseInt(birthdate.slice(4, 6), 10) - 1
            const day = parseInt(birthdate.slice(6, 8), 10)
            const date = new Date(year, month, day)

            if (
                date.getFullYear() !== year ||
                date.getMonth() !== month ||
                date.getDate() !== day
            ) {
                errors.birthdate = dict["birthdateConfirmationError"]
            }
        }
        console.log("error:", errors)
        setError(errors)
        return errors
    }

    function showFirstError(errors) {
        const firstErrorField = Object.keys(errors)[0]
        if (firstErrorField) {
            presentAlert({
                header: dict["alertTitle"],
                message: errors[firstErrorField],
                buttons: ["OK"]
            })
        }
    }

    const clearError = (field) => {
        setError((prevErrors) => {
            const updatedErrors = { ...prevErrors }
            delete updatedErrors[field]
            return updatedErrors
        })
    }

    const handleBlur = (field, value) => {
        
        if (!value) {
            setError((prevErrors) => ({
                ...prevErrors,
                [field]: dict[`${field}ValidationError`] || "This field is required."
            }))
        }
    }

    useEffect(() => {
        if(!isActive) return;
        // setSelectedDot(0)
        
        // console.log("user profile data page updated")
        try {
            // console.log(bot)
            if (Object.keys(bot["profileObj"]).length > 0 && bot["profileObj"].hasOwnProperty("longMem") && typeof bot["profileObj"]["longMem"] !== "string") {
                // there are existing profiles to display. Replace the current one.
                if (bot["profileObj"]["longMem"].hasOwnProperty("userNickname") && bot["profileObj"]["longMem"]["userNickname"] !== "") {
                    updateUserNickname(bot["profileObj"]["longMem"]["userNickname"])
                }
                if (bot["profileObj"]["longMem"].hasOwnProperty("botNickname") && bot["profileObj"]["longMem"]["botNickname"] !== "") {
                    updateBotNickname(bot["profileObj"]["longMem"]["botNickname"])
                }
                if (bot["profileObj"]["longMem"].hasOwnProperty("userBirthdate") && bot["profileObj"]["longMem"]["userBirthdate"] !== "") {
                    updateBirthdate(bot["profileObj"]["longMem"]["userBirthdate"])
                }
                if (bot["profileObj"]["longMem"].hasOwnProperty("userGender") && bot["profileObj"]["longMem"]["userGender"] !== "") {
                    updateGender(bot["profileObj"]["longMem"]["userGender"])
                }
                if (bot["profileObj"]["longMem"].hasOwnProperty("relation") && bot["profileObj"]["longMem"]["relation"] !== "") {
                    updateRelation(bot["profileObj"]["longMem"]["relation"])
                }
                if (bot["profileObj"]["longMem"].hasOwnProperty("userOccupation") && bot["profileObj"]["longMem"]["userOccupation"] !== "") {
                    updateOccupation(bot["profileObj"]["longMem"]["userOccupation"])
                }
            }
        }
        catch (e) {

        }
        if (history.location.state && history.location.state.errors) {
            try{
                
                const errors = isValidData()
                setError(errors)
            }
            catch(e){
                console.error(e)
            }
        }
    }, [
        isActive,
        bot
    ])

    return (
        <React.Fragment>
            <AppNavigator2
                title={dict["pageTitle"]}
                onBackClicked={() => {
                    presentAlert({
                        header: dict["isBackToLoginTitle"],
                        message: dict["isBackToLoginMessage"],
                        buttons: [
                            {
                                text: dict["cancelText"],
                                role: "cancel",
                            },
                            {
                                text: dict["yesText"],
                                handler: () => {
                                    resetSession()
                                    return history.push('/')
                                }
                            }
                        ]
                    })
                    return false
                }}

                onBackToChatRoomClicked={
                    bot?.id && bot?.profileObj?.isEditProfile === true ?  () => { 
                        presentAlert({
                            header: dict["isBackToChatRoomTitle"],
                            message: dict["isBackToChatRoomMessage"],
                            buttons: [
                                {
                                    text: dict["cancelText"],
                                    role: "cancel"
                                },
                                {
                                    text: dict["yesText"],
                                    handler: () => {
                                        return history.push('/chatroom/pdfbot');
                                    }
                                }
                            ]
                        });
                    } : null
                }
            />
            <Grid container
                direction={{
                    xs: "column",
                    md: "row"
                }}
                sx={{
                    flex: 1,
                    bgcolor: 'background.gray',
                    height: `calc(100vh - ${config.headerHeight}px)`,
                    overflowY: {
                        sm: "scroll",
                        md: "hidden"
                    }
                }}
            >
                <Grid item
                    sx={{
                        flex: {
                            xs: .2,
                            sm: .2,
                            md: 1
                        },
                        height: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: {
                            sm: 'center',
                            md: "flex-start"
                        },
                        alignItems: "center"
                        // bgcolor: 'background.default'
                    }}
                >
                    {/*<Stack
                        direction={"column"}
                        justifyContent={{
                            xs: "center",
                            lg: "flex-start"
                        }}
                        alignItems={"center"}
                        spacing={4}
                        sx={{
                            // bgcolor: 'background.dark',
                            width: 1,
                            px: {
                                xs: 4,
                                sm: 6,
                                md: 8
                            },
                            py: {
                                xs: 4,
                                sm: 6,
                                md: 8
                            }
                        }}
                    >
                        <Texts.H4
                            sx={{
                                color: 'primary.dark'
                            }}
                        >Avatar Profile Setup</Texts.H4>
                        <Texts.Tip>In this section, you will be guided through the profile setup steps. The whole process can take up to 10 minutes.</Texts.Tip>
                        <Box
                            sx={{
                                width: '240px',
                                display: {
                                    xs: 'none',
                                    md: 'block'
                                }
                            }}
                        >
                            <Images.LifeDetails />
                        </Box>
                        <DotIndicator selectedDot={selectedDot} setSelectedDot={setSelectedDot} />
                    </Stack>*/}
                    {/*<LeftProgressPanel history={history} selectedDot={selectedDot} setSelectedDot={setSelectedDot} />*/}
                    {children}
    
                </Grid>
                <Grid item
                    sx={{
                        flex: 1,
                        height: {
                            md: 1
                        },
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: "flex-start",
                        alignItems: "center",
                        bgcolor: 'background.default',
                        overflowY: "scroll"
                    }}
                >
                    <Stack
                        spacing={4}
                        direction={"column"}
                        sx={{
                            width: 1,
                            px: {
                                xs: 4,
                                sm: 6,
                                md: 8
                            },
                            py: {
                                xs: 4,
                                sm: 6,
                                md: 8
                            }
                        }}
                    >
                        {/* <Texts.H4
                            sx={{
                                color: 'primary.dark'
                            }}
                        >
                            {dict["userDetailsTitle"]}
                        </Texts.H4> */}
                        {/* <Texts.Paragraph>
                            {dict["sectionExplain2"]}
                        </Texts.Paragraph> */}
                        {/* <Divider /> */}
                        <Box>
                            <Texts.Tip><MustAsterik />{`${dict["asterik"]}`}</Texts.Tip>
                        </Box>
                        <Box>
                            <Texts.Tip>{`${dict["userNameLabel"]}`}<MustAsterik /></Texts.Tip>
                            <Forms.TextInput
                                value={userNickname}
                                onChange={(e) => {
                                    const nameValue = e.target.value
                                    updateUserNickname(nameValue)
                                    updateBotProfileBulk({
                                        profileObj: {
                                            ...bot.profileObj,
                                            longMem: {
                                                ...bot.profileObj.longMem,
                                                'userNickname': e.target.value
                                            }
                                        }
                                    })
                                    clearError("userNickname")
                                }}
                                error={error.userNickname || ""}
                                onBlur={(e) => {handleBlur("userNickname", e.target.value)}}
                                helperText={dict["userNameHelpingText"]}
                            />
                        </Box>
                        <Box>
                            <Texts.Tip>{dict["userNicknameLabel"]}<MustAsterik /></Texts.Tip>
                            <Forms.TextInput
                                value={botNickname}
                                onChange={(e) => {
                                    updateBotNickname(e.target.value)
                                    updateBotProfileBulk({
                                        profileObj: {
                                            ...bot.profileObj,
                                            longMem: {
                                                ...bot.profileObj.longMem,
                                                'botNickname': e.target.value
                                            }
                                        }
                                    })
                                    clearError("botNickname")
                                }}
                                error={error.botNickname || ""}
                                onBlur={(e) => {handleBlur("botNickname", e.target.value)}}
                                helperText={dict["botNicknameHelpingText"]}
                            />
                        </Box>
                        <Box>
                            <Texts.Tip>{dict["userBirthdateLabel"]}<MustAsterik /></Texts.Tip>
                            <Forms.TextInput
                                type="text"
                                placeholder="YYYYMMDD"
                                value={birthdate}
                                onChange={(e) => {
                                    updateBirthdate(e.target.value)
                                    updateBotProfileBulk({
                                        profileObj: {
                                            ...bot.profileObj,
                                            longMem: {
                                                ...bot.profileObj.longMem,
                                                'userBirthdate': e.target.value
                                            }
                                        }
                                    })
                                    clearError("birthdate")
                                }}
                                error={error.birthdate || ""}
                                onBlur={(e) => {handleBlur("birthdate", e.target.value)}}
                           
                            />
                        </Box>
                        <Box>
                            <Texts.Tip sx={{ mb: 1 }}>{dict["userGenderLabel"]}<MustAsterik /></Texts.Tip>
                            <Forms.SelectItem
                                label={dict["userGenderLabel"]}
                                id='user-gender'
                                inputValue={gender}
                                handleInput={(e) => {
                                    // console.log("eee:", e)
                                    updateGender(e.target.value)
                                    updateBotProfileBulk({
                                        profileObj: {
                                            ...bot.profileObj,
                                            longMem: {
                                                ...bot.profileObj.longMem,
                                                'userGender': e.target.value
                                            }
                                        }
                                    })
                                    clearError("gender")
                                }}
                                onBlur={(e) => {handleBlur("gender", e.target.value)}}
                                options={optionsArr}
                                error={error.gender || ""}
                            />
                        </Box>
                        <Box>
                            <Texts.Tip>{dict["userRelationLabel"]}<MustAsterik /></Texts.Tip>
                            <Forms.TextInput
                                value={relation}
                                onChange={(e) => {
                                    updateRelation(e.target.value)
                                    updateBotProfileBulk({
                                        profileObj: {
                                            ...bot.profileObj,
                                            longMem: {
                                                ...bot.profileObj.longMem,
                                                'relation': e.target.value
                                            }
                                        }
                                    })
                                    clearError("relation")
                                }}
                                error={error.relation || ""}
                                onBlur={(e) => {handleBlur("relation", e.target.value)}}
                            />
                        </Box>
                        <Box>
                            <Texts.Tip>{dict["userOccupationLabel"]}<MustAsterik /></Texts.Tip>
                            <Forms.TextInput
                                value={occupation}
                                onChange={(e) => {
                                    updateOccupation(e.target.value)
                                    updateBotProfileBulk({
                                        profileObj: {
                                            ...bot.profileObj,
                                            longMem: {
                                                ...bot.profileObj.longMem,
                                                'userOccupation': e.target.value
                                            }
                                        }
                                    })
                                    clearError("occupation")
                                }}
                                error={error.occupation || ""}
                                onBlur={(e) => {handleBlur("occupation", e.target.value)}}
                           
                            />
                        </Box>
                        <Buttons.Button
                            style={{
                                marginLeft: "auto",
                                marginRight: "0px"
                            }}
                            onClick={() => {
                                const errors = isValidData()
                                if (Object.keys(errors).length > 0) {
                                    showFirstError(errors); 
                                } else {
                                    setSelectedDot(1)
                                    updateBotProfileBulk({
                                        profileObj:{
                                            ...bot.profileObj,
                                            longMem: {
                                                ...bot.profileObj.longMem,
                                                userNickname: userNickname,
                                                botNickname: botNickname,
                                                userBirthdate: birthdate,
                                                userGender: gender,
                                                relation: relation,
                                                userOccupation: occupation
                                            }
                                        }
                                    })
                                    history.push('/profilesetup/demo-profile')
                                }
                            }}
                        >
                            {dict["submitButton"] }
                        </Buttons.Button>
                    </Stack>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default UserProfileDetails;
